import InfoIndicator from "@app/shared/InfoIndicator";
import * as React from "react";

interface SummaryTileProps {
  content: React.ReactNode;
  infoIndicatorText?: string;
  isPercent?: boolean;
  topRightContent?: React.ReactNode;
  title: string;
}

interface SummaryTileState {
  content: React.ReactNode;
  title: string;
}

export default class SummaryTile extends React.Component<SummaryTileProps, SummaryTileState> {
  constructor(props: SummaryTileProps) {
    super(props);
    this.state = {
      content: props.content,
      title: props.title,
    };
  }

  public render() {
    return (
      <div className="summary-tile">
        <div className="summary-tile__title-wrapper">
          <h2 className="summary-tile__title">
            {this.props.title}
            {this.props.infoIndicatorText &&
              <sup className="summary-tile__superscript-tooltip-indicator">&nbsp;<InfoIndicator className="informational-indicator" tooltipTitle={this.props.infoIndicatorText} tooltipPlacement="top" /></sup>}
            <span className="summary-tile__tr-corner-content">{this.props.topRightContent ? this.props.topRightContent : null}</span>
          </h2>
        </div>
        <div className="summary-tile__content">
          <div className="summary-tile__copy">{this.props.content}{this.props.isPercent && <>%</>}</div>
        </div>
      </div>
    );
  }
}
